import { useState, useEffect, useCallback } from 'react'

// Functions
import isExact from 'functions/is-exact'

const useGroups = (rawGroups, includeEmpty = true, emptyText = 'Tüm Gruplar') => {
	const calculateGroups = useCallback((groups) => {
		if(groups) {
			let returnGroups = groups.map((group) => {
				return { ...group, value: group.store_code, label: group.name }
			});

			if(includeEmpty) {
				returnGroups.unshift({value: '', label: emptyText})
			}

			return returnGroups;
		}
		else { return []; }
	}, [includeEmpty, emptyText]);

	const [groupData, setGroupData] = useState(calculateGroups(rawGroups));

	useEffect(() => {
		let newGroups = calculateGroups(rawGroups);
		if(!isExact(groupData, newGroups)) {
			setGroupData(newGroups);
		}

	}, [groupData, rawGroups, calculateGroups])

	return groupData;
}

export default useGroups;